import { normalizeApiBaseUrl } from './apiBaseUrl';

function isLoopbackHost(hostname: string): boolean {
  const host = hostname.replace(/^\[|\]$/g, '');
  return host === 'localhost' || host === '127.0.0.1' || host === '::1';
}

/** Phone browsers only expose getUserMedia on HTTPS (localhost is the exception). */
export function secureRoomCameraUrl(pageUrl: string): string | null {
  let url: URL;
  try {
    url = new URL(pageUrl);
  } catch {
    return null;
  }
  if (url.protocol !== 'http:' || isLoopbackHost(url.hostname)) return null;
  if (url.port && url.port !== '80') return null;
  url.protocol = 'https:';
  url.port = '';
  return url.toString();
}

export function friendlyCameraError(error: unknown): string {
  const raw = error instanceof Error ? error.message : '';
  if (/getUserMedia|mediaDevices|undefined is not an object/i.test(raw)) {
    return 'This browser is not offering a camera. Open the link in Safari or Chrome, and allow camera access for the site.';
  }
  return raw || 'Camera permission is required';
}

export function roomCameraBlockedReason(pageUrl: string, mediaDevicesAvailable: boolean): string | null {
  if (secureRoomCameraUrl(pageUrl)) {
    return 'This page is open over HTTP. The phone camera stays hidden until you open the HTTPS address.';
  }
  if (!mediaDevicesAvailable) {
    return 'This browser is not offering a camera. Open the link in Safari or Chrome, and allow camera access for the site.';
  }
  return null;
}

/** Frames must reach the computer that served the page, not the phone's own localhost. */
export function roomCameraApiRoot(pageUrl: string, configuredApiUrl: string): string {
  const configured = normalizeApiBaseUrl(configuredApiUrl);
  let root = configured;
  try {
    const page = new URL(pageUrl);
    const configuredHost = configured ? new URL(configured).hostname : '';
    const pageIsLoopback = isLoopbackHost(page.hostname);
    const configuredIsLoopback = !configuredHost || isLoopbackHost(configuredHost);
    if (!pageIsLoopback && configuredIsLoopback) {
      root = page.origin;
    } else if (!root) {
      root = page.origin;
    }
  } catch {
    root = root || '';
  }
  return `${root}/api`;
}
